import JSEncrypt from 'jsencrypt';
import PUBLIC_KEY from './keys/publickeyzz.key.pub';

const jsEncrypt = new JSEncrypt();
fetch(PUBLIC_KEY)
    .then(key => key.text())
    .then(PUBLIC_KEY => {
        jsEncrypt.setPublicKey(PUBLIC_KEY);
    })

export async function encryptIt(data) {
    let encryptedDataArray = []

    // for (var i = 0; i < JSON.stringify(data).match(/.{1,100}/g).length; i++) {
    //     encryptedDataArray.push(jsEncrypt.encrypt((JSON.stringify(data).match(/.{1,100}/g)[i])))
    // }

    JSON.stringify(data).match(/.{1,100}/g).map((msg, index) => encryptedDataArray.push(jsEncrypt.encrypt((msg))))
    return encryptedDataArray
}